import { LogEvent } from 'src/app/interfaces/log';
import { EventLoggingParams, LogEventKey } from '../../../interfaces/log';
import { LogService } from '../log.service';
import { QuizReportType } from '../../../interfaces/quiz';

export class IdealTypeQuizLogService {
  constructor(private logService: LogService) {

  }

  rankingItemClicked(id: number): void {
    this.eventLogging(LogEvent.IDEAL_TYPE_QUIZ_REPORT_RANKING_ITEM_CLICKED, { id });
  }

  quizIntroScreenViewed(): void {
    this.eventLogging(LogEvent.IDEAL_TYPE_QUIZ_INTRO_SCREEN_VIEWED);
  }

  quizQuestionnaireScreenViewed(): void {
    this.eventLogging(LogEvent.IDEAL_TYPE_QUIZ_QUESTIONNAIRE_SCREEN_VIEWED);
  }

  replyIntroScreenViewed(): void {
    this.eventLogging(LogEvent.IDEAL_TYPE_REPLY_INTRO_SCREEN_VIEWED);
  }

  replyQuestionnaireScreenViewed(): void {
    this.eventLogging(LogEvent.IDEAL_TYPE_REPLY_QUESTIONNAIRE_SCREEN_VIEWED);
  }

  quizCreateSubmit(): void {
    this.eventLogging(LogEvent.IDEAL_TYPE_QUIZ_CREATE_SUBMIT, { screenName: 'ideal_type_quiz_create' });
  }

  reportDetailNextClicked(nextStep: number): void {
    this.eventLogging(LogEvent.IDEAL_TYPE_QUIZ_REPORT_DETAIL_NEXT_CLICKED, { nextStep });
  }

  reportDetailPrevClicked(nextStep: number): void {
    this.eventLogging(LogEvent.IDEAL_TYPE_QUIZ_REPORT_DETAIL_PREV_CLICKED, { nextStep });
  }

  reportDetailViewed(): void {
    this.eventLogging(LogEvent.IDEAL_TYPE_QUIZ_REPORT_DETAIL_SCREEN_VIEWED);
  }

  replyReportDetailViewed(standard: 'host' | 'guest'): void {
    this.eventLogging(LogEvent.IDEAL_TYPE_REPLY_REPORT_DETAIL_SCREEN_VIEWED, { standard });
  }

  replyCreateSubmit(): void {
    this.logService.eventLogging(LogEvent.IDEAL_TYPE_REPLY_CREATE_SUBMIT, { screenName: 'ideal_type_reply_create' });
  }

  quizBack(currentStep: number): void {
    this.logService.eventLogging(LogEvent.IDEAL_TYPE_QUIZ_BACK, { currentStep });
  }

  quizFinish(currentStep: number): void {
    this.logService.eventLogging(LogEvent.IDEAL_TYPE_QUIZ_FINISH, { currentStep });
  }

  quizNext(currentStep: number): void {
    this.logService.eventLogging(LogEvent.IDEAL_TYPE_QUIZ_NEXT, { currentStep });
  }

  quizReportScreenViewed(): void {
    this.eventLogging(LogEvent.IDEAL_TYPE_QUIZ_REPORT_SCREEN_VIEWED);
  }

  quizReportMbtiQuizButtonClicked(): void {
    this.eventLogging(LogEvent.IDEAL_TYPE_QUIZ_REPORT_MBTI_QUIZ_BUTTON_CLICKED);
  }

  quizReportAnswerDetailButtonClicked(): void {
    this.eventLogging(LogEvent.IDEAL_TYPE_QUIZ_REPORT_ANSWER_DETAIL_BUTTON_CLICKED);
  }

  quizReportDatingStyleButtonClicked(): void {
    this.eventLogging(LogEvent.IDEAL_TYPE_QUIZ_REPORT_DATING_STYLE_BUTTON_CLICKED);
  }

  quizReportSurveyItemClicked(content: string, type: string): void {
    this.eventLogging(LogEvent.IDEAL_TYPE_QUIZ_REPORT_SURVEY_ITEM_CLICKED, { content, type });
  }

  quizReportAllSurveyButtonClicked(): void {
    this.eventLogging(LogEvent.IDEAL_TYPE_QUIZ_REPORT_ALL_SURVEY_BUTTON_CLICKED);
  }

  quizReportAppstoreFloatingButtonClicked(): void {
    this.eventLogging(LogEvent.IDEAL_TYPE_QUIZ_REPORT_APPSTORE_FLOATING_BUTTON_CLICKED);
  }

  replyReportScreenViewed(standard: 'host' | 'guest'): void {
    this.eventLogging(LogEvent.IDEAL_TYPE_REPLY_REPORT_SCREEN_VIEWED, { standard });
  }

  replyReportChemiButtonClicked(): void {
    this.eventLogging(LogEvent.IDEAL_TYPE_REPLY_REPORT_CHEMI_BUTTON_CLICKED);
  }

  replyReportAnswerDetailButtonClicked(): void {
    this.eventLogging(LogEvent.IDEAL_TYPE_REPLY_REPORT_ANSWER_DETAIL_BUTTON_CLICKED);
  }

  replyReportBackToRankingButtonClicked(): void {
    this.eventLogging(LogEvent.IDEAL_TYPE_REPLY_REPORT_BACK_TO_RANKING_BUTTON_CLICKED);
  }

  replyReportIdealTypeQuizButtonClicked(type: 'description' | 'sticky-footer' | 'footer'): void {
    this.eventLogging(LogEvent.IDEAL_TYPE_REPLY_REPORT_IDEAL_TYPE_QUIZ_BUTTON_CLICKED, { type });
  }

  characterChangeButtonClicked(): void {
    this.eventLogging(LogEvent.IDEAL_TYPE_QUIZ_CHARACTER_CHANGE_BUTTON_CLICKED);
  }

  quizReportMyMbtiChangeButtonClicked(): void {
    this.eventLogging(LogEvent.IDEAL_TYPE_QUIZ_REPORT_MY_MBTI_CHANGE_BUTTON_CLICKED);

  }

  quizReportShowAllRankingButtonClicked(): void {
    this.eventLogging(LogEvent.IDEAL_TYPE_QUIZ_REPORT_SHOW_ALL_RANKING_BUTTON_CLICKED);
  }

  quizReportShareButtonClicked(type: 'copy' | 'kakao'): void {
    this.eventLogging(LogEvent.IDEAL_TYPE_QUIZ_REPORT_SHARE_BUTTON_CLICKED, { type });
  }

  quizReportQrCodeButtonClicked(): void {
    this.eventLogging(LogEvent.IDEAL_TYPE_QUIZ_REPORT_QR_CODE_BUTTON_CLICKED);
  }
  quizReportFloatingBannerClicked(): void {
    this.eventLogging(LogEvent.IDEAL_TYPE_QUIZ_REPORT_FLOATING_BANNER_CLICKED)
  }
  idealTypeSelectViewed(type?: QuizReportType): void {
    const from = 'mbti_ideal_type_quiz'
    this.eventLogging(LogEvent.IDEAL_TYPE_SELECT_VIEWED, { type, from })
  }
  idealTypeSelectCardClicked(type?: QuizReportType): void {
    const from = 'mbti_ideal_type_quiz'
    this.eventLogging(LogEvent.IDEAL_TYPE_SELECT_CARD_CLICKED, { type, from });
  }
  idealTypeSelectCreateNewClicked(): void {
    const from = 'mbti_ideal_type_quiz'
    this.eventLogging(LogEvent.IDEAL_TYPE_SELECT_CREATE_NEW_CLICKED, { from });
  }
  private eventLogging(event: LogEventKey, params?: EventLoggingParams): void {
    this.logService.eventLogging(event, {
      ...params
    });
  }
}